"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAV_ACTIVITY_TO_SORT_COPY = exports.ACCOUNT_MENU_LOG_OUT_COPY = exports.ACCOUNT_MENU_DARK_MODE_COPY = exports.ACCOUNT_MENU_HELP_COPY = exports.ACCOUNT_MENU_SUBSCRIPTION_COPY = exports.ACCOUNT_MENU_BANKS_COPY = exports.ACCOUNT_MENU_SETTINGS_COPY = exports.NAV_UPCOMING_LIST_COPY = exports.NAV_UPCOMING_PAY_PERIODS_COPY = exports.NAV_UPCOMING_MONTH_COPY = exports.NAV_DEBT_PAYOFF_COPY = exports.NAV_REPEATING_COPY = exports.NAV_REVIEW_MY_DATA_COPY = exports.NAV_INSIGHTS_COPY = exports.NAV_UPCOMING_COPY = exports.NAV_ACTIVITY_COPY = exports.NAV_PLAN_COPY = exports.NAV_HOME_COPY = exports.MORE_HELP_COPY = exports.MORE_RULES_COPY = exports.MORE_BANKS_COPY = exports.TAB_MORE_COPY = exports.TAB_FORECAST_COPY = exports.TAB_TRANSACTIONS_COPY = exports.TAB_BUDGET_COPY = exports.TAB_HOME_COPY = void 0;
exports.navActivityLabel = navActivityLabel;
/**
 * The phone-width tab bar's words (Anthony's Transactions redesign, Phase 3; tabs and
 * More approved by Paul 2026-10-08, report -102). One source for both clients (rule 17;
 * mobile agreed the labels in writing). `*_COPY` names keep them in the copy inventory.
 *
 * The five tabs are Anthony's words. More lists every other destination; its items reuse
 * each page's existing name where one exists (Calendar, Goals, … come from the nav), and
 * these keys cover the ones the drawer never listed.
 */
exports.TAB_HOME_COPY = "Home";
exports.TAB_BUDGET_COPY = "Budget";
exports.TAB_TRANSACTIONS_COPY = "Transactions";
exports.TAB_FORECAST_COPY = "Forecast";
exports.TAB_MORE_COPY = "More";
/** More's items that were never in the drawer (reached from menus and page links). */
exports.MORE_BANKS_COPY = "Connected Banks";
exports.MORE_RULES_COPY = "Rules";
exports.MORE_HELP_COPY = "Help";
/**
 * The five-item navigation (Anthony's redesign, 2026-10-13): one question per page.
 * The sidebar, the web phone tab bar and, when mobile adopts the redesign, mobile's
 * tabs all read these. The phone-tab keys above stay until mobile moves over.
 */
exports.NAV_HOME_COPY = "Home";
exports.NAV_PLAN_COPY = "Plan";
exports.NAV_ACTIVITY_COPY = "Activity";
exports.NAV_UPCOMING_COPY = "Upcoming";
exports.NAV_INSIGHTS_COPY = "Insights";
/** The plain name for Financial Analysis inside Insights ("Plain names" rule). */
exports.NAV_REVIEW_MY_DATA_COPY = "Review my data";
/** The plain name for Recurring inside Upcoming. */
exports.NAV_REPEATING_COPY = "Bills & income";
/**
 * Anthony's package (close_spec/, 2026-10-28; I1, A5, Plan Pages' nav, workflow 3.12): the
 * nav is Home, Plan, Upcoming, Insights. Plan's two entries are Your plan (PLAN_TITLE_COPY)
 * and Debt payoff; Upcoming's views are Month, Pay periods and List. Activity leaves the
 * nav (its page stays, reached from Home's latest purchases).
 */
exports.NAV_DEBT_PAYOFF_COPY = "Debt payoff";
exports.NAV_UPCOMING_MONTH_COPY = "Month";
exports.NAV_UPCOMING_PAY_PERIODS_COPY = "Pay periods";
exports.NAV_UPCOMING_LIST_COPY = "List";
/** The account menu at the foot of the sidebar, in the spec's order. */
exports.ACCOUNT_MENU_SETTINGS_COPY = "Settings & profile";
exports.ACCOUNT_MENU_BANKS_COPY = "Connected banks";
exports.ACCOUNT_MENU_SUBSCRIPTION_COPY = "Subscription";
exports.ACCOUNT_MENU_HELP_COPY = "Help & support";
exports.ACCOUNT_MENU_DARK_MODE_COPY = "Dark mode";
exports.ACCOUNT_MENU_LOG_OUT_COPY = "Log out";
/**
 * RD-02: the Activity item's badge counts this pay period's purchases to sort (Paul's
 * Q6), Anthony's word from Home's "Purchases to sort". The spoken name carries the exact
 * count, "Activity, 12 to sort"; any cap ("9+" on a phone, "99+" in the sidebar) is
 * visual only and each app keeps its own. At 0 it is the bare label.
 */
exports.NAV_ACTIVITY_TO_SORT_COPY = "to sort";
function navActivityLabel(count) {
    return count > 0
        ? `${exports.NAV_ACTIVITY_COPY}, ${count} ${exports.NAV_ACTIVITY_TO_SORT_COPY}`
        : exports.NAV_ACTIVITY_COPY;
}
//# sourceMappingURL=navTabsCopy.js.map